import {AfterViewInit, Component, ElementRef, EventEmitter, HostBinding, Input, Output} from '@angular/core';
import {Router} from "@angular/router";
import {SimpleWord} from "../../models/simple-word.model";
import {WORD_LIST_MEANING} from "../../defines/desktop.const";
import {multiLinkMixin} from "../../mixin/multi-link.mixin";
import {GetPoomsaTxt} from '../../defines/gukeo.func';
import {listItemId} from "../../defines/client.func";
import {WordHistoryService} from "../../services/word/word-history.service";
import {DynamicComponentService} from "../../services/dynamic-component/dynamic-component.service";

@Component({
  selector: 'app-word-list-item',
  templateUrl: './word-list-item.component.html',
  styleUrls: ['./word-list-item.component.scss']
})
export class WordListItemComponent extends multiLinkMixin implements AfterViewInit {
  /**
   * TODO: MultiLinkMixin을 삭제해야 함. 현재 사용하지 않음
   *       WordDetailHomonymComponent 에서 사용하기위하여 MultiLinkMixin 을 상속받음.
   *       하지만 현재 기획이 변경되어 WordDetailHomonymComponent 에서 팝업창을 열지 않음.
   */
  @HostBinding('style.display') styleBlock = 'block';
  @Input() word?: SimpleWord;
  @Input() showLevel = true;
  @Output() viewInit: EventEmitter<SimpleWord> = new EventEmitter<SimpleWord>();

  protected readonly GetPoomsaTxt = GetPoomsaTxt;
  protected readonly listItemId = listItemId;

  constructor(
    public override router: Router,
    public override wHistorySvc: WordHistoryService,
    public override dynamicSvc: DynamicComponentService,
    protected elementRef: ElementRef,
  ) {
    super(router, wHistorySvc, dynamicSvc);
  }

  ngAfterViewInit() {
    this.viewInit.emit(this.word);
  }

  public get offsetTop(): number {
    return this.elementRef.nativeElement.offsetTop;
  }

  /**
   * TODO: 제거하고, SimpleWord::GetMeaningNth(...)로 대체해야 함
   */
  protected getDefaultMeaning(word: SimpleWord): string | null {
    return word?.meaning?.[0] ?? null;
  }

  /**
   * TODO: 제거하고, SimpleWord::GetMeaningNth(...)로 대체해야 함
   */
  protected getNumberedMeanings(word: SimpleWord): Array<string> | null {
    return word?.meaning?.slice(1, WORD_LIST_MEANING + 1) ?? null;
  }

  /**
   * TODO: 제거하고, SimpleWord::GetMeaningNth(...)로 대체해야 함
   */
  protected getMoreMeanings(word: SimpleWord): number {
    // const more = Math.max(0, (word?.meaning?.length ?? 0) - WORD_LIST_MEANING - 1)
    // console.warn('getMoreMeanings() ', more);
    return Math.max(0, (word?.meaning?.length ?? 0) - WORD_LIST_MEANING - 1);
  }


}
